import React, { useEffect, useMemo, useState } from "react";
import { Table, Tag, Typography, Button, Input, Select, Space } from "antd";
import { useNavigate } from "react-router-dom";

import { privateAdminGetApi } from "../../utils/apiHelper";

const { Title } = Typography;

const PLAN_FILTER_OPTIONS = [
  { value: "free", label: "Free" },
  { value: "paid", label: "Paid" },
];

const columns = (navigate) => [
  {
    title: "Organization",
    dataIndex: "name",
    key: "name",
    render: (name, record) => (
      <Button
        type="link"
        style={{ padding: 0, height: "auto" }}
        onClick={() => navigate(`/admin/organizations/${record._id}`)}
      >
        {name}
      </Button>
    ),
  },
  {
    title: "Email plan",
    dataIndex: "plan",
    key: "plan",
    render: (v) => <Tag>{v}</Tag>,
  },
  {
    title: "Forms plan",
    dataIndex: "formsPlan",
    key: "formsPlan",
    render: (v) => <Tag>{v}</Tag>,
  },
  { title: "Members", dataIndex: "members", key: "members" },
  { title: "Campaigns", dataIndex: "campaigns", key: "campaigns" },
  { title: "Forms", dataIndex: "forms", key: "forms" },
  {
    title: "Last active",
    dataIndex: "lastActiveAt",
    key: "lastActiveAt",
    render: (v) => (v ? new Date(v).toLocaleString() : "-"),
  },
  {
    title: "Created",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (v) => (v ? new Date(v).toLocaleDateString() : "-"),
  },
];

export default function AdminOrganizations() {
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [planFilter, setPlanFilter] = useState(undefined);

  useEffect(() => {
    privateAdminGetApi("admin/organizations")
      .then((res) => {
        setRecords(res.data.result.records);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // Filtered client-side -- this endpoint already returns every org in one
  // shot (other admin pages rely on that full list for their own org-filter
  // dropdowns), and at current scale that's cheaper than adding server-side
  // query params just for this one table's search box.
  const filteredRecords = useMemo(() => {
    const term = search.trim().toLowerCase();
    return records.filter((r) => {
      if (term && !r.name?.toLowerCase().includes(term)) return false;
      if (planFilter && r.plan !== planFilter) return false;
      return true;
    });
  }, [records, search, planFilter]);

  return (
    <div>
      <Title level={5} style={{ marginBottom: 16 }}>
        Organizations
      </Title>
      <Space style={{ marginBottom: 16 }}>
        <Input.Search
          allowClear
          placeholder="Search by name"
          style={{ width: 240 }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Select
          allowClear
          placeholder="Email plan"
          style={{ width: 140 }}
          value={planFilter}
          onChange={setPlanFilter}
          options={PLAN_FILTER_OPTIONS}
        />
      </Space>
      <Table
        rowKey="_id"
        loading={loading}
        columns={columns(navigate)}
        dataSource={filteredRecords}
        pagination={{ pageSize: 25 }}
      />
    </div>
  );
}
